import apiClient from './apiClient';
import { API_ENDPOINTS } from './endpoints';

/**
 * Membership management (admin). Resolves with the raw body { IsSuccess, Data, Message }.
 */
const E = API_ENDPOINTS.MEMBERSHIP_ADMIN;
const post = async (url, body) => (await apiClient.post(url, body || {})).data;

const membershipAdminService = {
  list: (p) => post(E.LIST, p),
  detail: (id) => post(E.DETAIL, { id }),
  audit: (id) => post(E.AUDIT, id ? { id } : {}),
  options: (search) => post(E.OPTIONS, search ? { search } : {}),
  add: (p) => post(E.ADD, p),
  update: (p) => post(E.UPDATE, p),
  deactivate: (p) => post(E.DEACTIVATE, p),
  reactivate: (p) => post(E.REACTIVATE, p),
  remove: (p) => post(E.REMOVE, p),
};

export default membershipAdminService;
